/**
 * ブラウザが File に付与するローカルパスヒントを取り出す（非標準）。
 * Chromium / Electron 等で `file.path` があるときのみ絶対パスが取れる。
 * Web 標準の File System Access API では通常 null。
 */
export function extractLocalFilePathHint(file: File): string | null {
  const withPath = file as File & { path?: unknown };
  if (typeof withPath.path === 'string') {
    const trimmed = withPath.path.trim();
    if (trimmed && trimmed !== file.name) return trimmed;
  }
  return null;
}

/** 表示用: path があれば path、なければ name */
export function formatLocalZipFileLocation(entry: {
  name: string;
  path?: string | null;
}): string {
  const path = entry.path?.trim();
  if (path) return path;
  return entry.name;
}
